// extracted by mini-css-extract-plugin
export default {"container":"CaseUserAssignmentModal_container__49FTT"};